import { useState } from "react";

export default function Accordion({ items = [] }) {
  const [openItem, setOpenItem] = useState(null);

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const isOpen = openItem === index;
        const panelId = `accordion-panel-${index}`;

        return (
          <div className="accordion__item" key={item.title}>
            <button
              aria-controls={panelId}
              aria-expanded={isOpen}
              className="accordion__trigger"
              onClick={() => setOpenItem(isOpen ? null : index)}
              type="button"
            >
              <span>{item.title}</span>
              <span aria-hidden="true" className="accordion__icon" />
            </button>
            {isOpen && (
              <div className="accordion__panel" id={panelId}>
                {item.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
